import React, { useRef, useCallback } from 'react';
import pt from 'prop-types';
import styles from './MultiPose.module.scss';
import CarouselItem from './CarouselItem';
import backIcon from './back.png';
import nextIcon from './next.png';

export default function Carousel({ favoriteIds, items, onClick, useOrientation, background }) {
  const carouselRef = useRef();

  // Use useCallback to memoize these functions
  const goLeft = useCallback(() => {
    if (!carouselRef.current) return;
    
    // Add a small delay to ensure scroll completes before any potential click
    requestAnimationFrame(() => {
      carouselRef.current.scrollLeft -= 150;
    });
  }, []);

  const goRight = useCallback(() => {
    if (!carouselRef.current) return;
    
    requestAnimationFrame(() => {
      carouselRef.current.scrollLeft += 150;
    });
  }, []);

  const handleItemClick = useCallback((item) => {
    // Ensure the scroll has settled before handling the click
    setTimeout(() => {
      onClick(item);
    }, 50);
  }, [onClick]);

  return (
    <div className={styles.carouselWrapper}>
      <img 
        className={styles.carouselBtn} 
        alt="Back" 
        src={backIcon} 
        onClick={goLeft}
      />
      <div className={styles.carousel}>
        <div 
          className={styles.carouselItems} 
          ref={carouselRef}
        >
          {items.map((item) => (
            <CarouselItem
              key={item.id}
              favoriteIds={favoriteIds}
              item={item}
              useOrientation={useOrientation}
              onClick={() => handleItemClick(item)}
              background={background}
            />
          ))}
        </div>
      </div>
      <img 
        className={styles.carouselBtn} 
        alt="Next" 
        src={nextIcon} 
        onClick={goRight}
      />
    </div>
  );
}

Carousel.defaultProps = {
  favoriteIds: [],
};

Carousel.propTypes = {
  favoriteIds: pt.arrayOf(pt.number),
  items: pt.arrayOf(pt.shape({
    watermarkUrl: pt.string,
    imageUrl: pt.string.isRequired,
  })).isRequired,
  onClick: pt.func.isRequired
};
